module.exports = __webpack_public_path__ + "LatoLatin-Hairline.935f82fdaa028827c830.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Hairline.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Hairline.eot
// module chunks = styles